module.exports = "/assets/data/6bd903b90fa6bd2c36b600c047583847-NE42.data.json";